export default "__VITE_ASSET__CXAa36nr__"